<template>
  <page-wrapper ref="pageEl" :title="title">
    <loading-overlay :active="isLoading" />
    <div class="container-receipt">
      <div>
        <p v-if="total" class="mb-1 mt-2">{{ totalCount }}</p>
        <div class="d-flex flex-row justify-content-between">
          <div class="d-flex flex-row">
            <el-checkbox-group v-model="checkedFilters" :min="0" :max="1">
              <el-checkbox
                label="pack"
                @change="handlePackageNotSendEztax"
                ><p class="mb-1 mt-2">
                  แพ็กแรกพบที่ส่ง eztax ไม่ผ่าน
                </p></el-checkbox
              >
              <el-checkbox
                label="resend"
                @change="handleGetResendReceipt"
                ><p class="mb-1 mt-2">
                  ใบเสร็จที่ต้องการ Resend
                </p></el-checkbox
              >
            </el-checkbox-group>
            <div class="space md-2 ms-5">
              <el-select
                v-model="query.filterSellerTradeParty"
                placeholder="เลือก ผู้จัดหาบริการ"
                clearable @change="handleChangeSellerTradeParty"
              >
                <el-option
                  v-for="t in sellerTradePartyOptions"
                  :key="t.value"
                  :label="t.label"
                  :value="t.value"
                ></el-option>
              </el-select>
            </div>
          </div>
          <div class="ms-3 me-3">
            <sc-button
            :disabled="isViewOnlyByRole"
            class="primary"
            @click="handleCancelReceipt"
              >ยกเลิกใบเสร็จ</sc-button
            >
          </div>
        </div>
      </div>
      <div class="receipt-row header">
        <div class="cell date">วันที่</div>
        <div class="cell client">ผู้รับบริการ</div>
        <div class="cell type">ผู้จัดหาบริการ</div>
        <div class="cell type">ชนิด</div>
        <div class="cell total">ยอดรวม</div>
        <div class="cell reason">ไม่ส่งเพราะ</div>
      </div>
      <div v-if="!total && !isLoading" class="text-center mt-4">ไม่มีข้อมูล</div>
      <div class="mb-4">
        <router-link
          v-for="r in list"
          :key="r.id"
          :to="r.route"
          class="receipt-row"
        >
          <div class="cell date">{{ r.createdAt }}</div>
          <div class="cell client">{{ r.clientName }}</div>
          <div class="cell type">{{ r.sellerTradeParty }}</div>
          <div class="cell type">{{ r.type }}</div>
          <div class="cell total">{{ r.total }}</div>
          <div class="cell reason">{{ r.receiptNotSentReason }}</div>
        </router-link>
      </div>
      <el-drawer
        ref="drawer"
        :before-close="handleCloseCancelReceiptDialog"
        :visible.sync="cancelReceiptDialog.isShow"
        :with-header="false"
        title="ยกเลิกใบเสร็จ"
        direction="rtl"
        custom-class="demo-drawer"
      >
        <div class="ms-2 my-4 d-flex flex-column">
          <span class="col-12 drawer-title">ยกเลิกใบเสร็จ</span>
          <span class="col-12 drawer-sub-title">สามารถดูเลขที่ใบกำกับภาษี และผู้จัดหาบริการได้ที่หน้า รายละเอียดสมาชิก</span>
        </div>
        <div class="demo-drawer__content row">
          <div class="mx-4 mb-4">
            <label class="label col-12 mb-1">เลขที่ใบเสร็จ (ตามที่ส่ง EZTax)</label>
            <el-input
              v-model="cancelReceiptDialog.documentNumber"
              class="mb-3 col-12 input sellerTradeParty"
            ></el-input>
            <label class="label col-12 mb-1">ผู้จัดหาบริการ</label>
            <el-select
              v-model="cancelReceiptDialog.sellerTradePartyId"
              class="mb-4 col-12 input sellerTradeParty"
              placeholder="เลือกผู้จัดหาบริการ"
            >
              <el-option
                v-for="option in sellerTradePartyOptions"
                :key="option.value"
                :value="option.value"
                :label="option.label"
              >{{ option.label }}</el-option>
            </el-select>
            <div class="col-12">
              <el-button @click="handleCloseCancelReceiptDialog">ยกเลิก</el-button>
              <el-button
                :loading="cancelReceiptDialog.isLoading"
                type="primary"
                @click="handleConfirmCancelReceipt"
              >{{ cancelReceiptDialog.isLoading ? 'กำลังยกเลิกใบเสร็จ..' : 'ยกเลิกใบเสร็จ' }}</el-button>
            </div>
          </div>
        </div>
      </el-drawer>
      <div class="text-end me-3">
        <el-pagination
          :total="total"
          :page-size="10"
          :current-page="query.page"
          background
          layout="prev, pager, next"
          @current-change="handleCurrentChange"
        ></el-pagination>
      </div>
    </div>
  </page-wrapper>
</template>

<script>
import { baanRueJaiClient } from "@/dependencies";
import PageWrapper from "@/lib/components/PageWrapper";
import ScButton from "@/lib/components/ScButton";
import { formatDecimal, formatToMoney } from "@/lib/formatter";
import LoadingOverlay from "@/lib/components/LoadingOverlay";
import { receiptTypeTH } from "@/lib/mapper";

import {
  Button,
  Checkbox,
  CheckboxGroup,
  Drawer,
  Input,
  Option,
  Pagination,
  Select
} from "element-ui";
import { DateTime } from "luxon";
import { getAdminRolePermission } from "../adminRolePermission";

function emptyCancelDialog() {
  return {
    isShow: false,
    isLoading: false,
    documentNumber: "",
    sellerTradePartyId: ""
  };
}

export default {
  components: {
    PageWrapper,
    ScButton,
    LoadingOverlay,
    "el-pagination": Pagination,
    "el-drawer": Drawer,
    "el-select": Select,
    "el-option": Option,
    "el-button": Button,
    "el-input": Input,
    "el-checkbox": Checkbox,
    "el-checkbox-group": CheckboxGroup
  },
  data() {
    return {
      title: "รายการใบเสร็จ",
      list: [],
      total: 0,
      query: {},
      cancelReceiptDialog: emptyCancelDialog(),
      sellerTradeParties: [],
      checkedFilters: [],
      permission: getAdminRolePermission(),
      isLoading: false
    };
  },
  computed: {
    totalCount() {
      const limit = 10;
      const totalLabel = this.total.toLocaleString();
      const isLastPage = limit > this.list.length;
      const currentPage = this.query.page;
      const end = isLastPage ? totalLabel : currentPage * limit;
      const start = (
        (isLastPage ? limit * currentPage - limit : end - limit) + 1
      ).toLocaleString();

      return `แสดงผล ${start} - ${end} จากทั้งหมด ${totalLabel}`;
    },
    sellerTradePartyOptions() {
      return this.sellerTradeParties.map((seller) => ({
        value: seller.id,
        label: seller.name
      }));
    },
    isFilteredByPack() {
      return this.checkedFilters.includes("pack");
    },
    isFilteredByResend() {
      return this.checkedFilters.includes("resend");
    },
    isViewOnlyByRole() {
      const roles = ["AC"];

      return roles.includes(this.permission?.role);
    }
  },
  watch: {
    "$route.query": async function watchRouteQuery() {
      this.setupQuery();
      await this.setupData();

      const pageContent = this.$refs.pageEl?.$el?.querySelector(".page-content");
      if (pageContent) pageContent.scrollTop = 0;
    }
  },
  created() {
    this.setup();
  },
  methods: {
    async setup() {
      await this.setupSellerTradeParties();
      this.setupQuery();
      await this.setupData();
    },
    setupQuery() {
      const toBool = (v) => v === true || v === "true";
      const isFilteredByPack = toBool(this.$route.query.isFilteredByPack);
      const isFilteredByResend = toBool(this.$route.query.isFilteredByResend);

      this.query = {
        page: parseInt(this.$route.query.page, 10) || 1,
        isFilteredByPack,
        isFilteredByResend,
        filterSellerTradeParty: this.$route.query.filterSellerTradeParty
      };

      if (isFilteredByPack && !this.checkedFilters.includes("pack"))
        this.checkedFilters.push("pack");
      if (isFilteredByResend && !this.checkedFilters.includes("resend"))
        this.checkedFilters.push("resend");
    },
    async setupData() {
      await this.setupList();
    },
    async setupSellerTradeParties() {
      const response =
        await baanRueJaiClient.admin.subscriptions.receipts.getAllSellerTradeParties();

      this.sellerTradeParties = response.data.result;
    },
    async setupList() {
      this.isLoading = true;
      const { count, receipts } = this.query.isFilteredByResend
        ? await this.fetchResendList()
        : await this.fetchUnsentList();

      this.total = count;
      this.list = receipts.map((receipt) => this.mapReceiptToRow(receipt));
    },
    mapReceiptToRow(receipt) {
      const amount = receipt.amount || 0;
      const priceBeforeDiscount =
        receipt.price_before_discount !== null &&
        receipt.price_before_discount >= 0
          ? receipt.price_before_discount
          : formatDecimal(amount) * receipt.quantity;

      const sellerTradeParty =
        this.sellerTradeParties.find(
          (i) => i.id === receipt.seller_trade_party_id
        )?.name || "-";

      let receiptNotSentReason;
      if (receipt.is_manual_payment) {
        receiptNotSentReason = "ซื้อนอกระบบ";
      } else if (
        receipt.is_non_verify_sales !== null &&
        receipt.is_non_verify_sales
      ) {
        receiptNotSentReason = "ซื้อโดยไม่สมัคร App";
      } else {
        receiptNotSentReason = "-";
      }

      this.isLoading = false;
      return {
        id: receipt.id,
        docNo: receipt.document_number || "-",
        createdAt: DateTime.fromISO(receipt.created_at)
          .setZone("utc+7")
          .setLocale("th")
          .toFormat("dd MMM yyyy"),
        clientName: receipt.owner_name,
        total: formatToMoney(priceBeforeDiscount),
        type: receiptTypeTH[receipt.type],
        route: { name: "ReceiptDetailPage", params: { id: receipt.id } },
        sellerTradeParty,
        receiptNotSentReason
      };
    },
    async fetchUnsentList() {
      const response =
        await baanRueJaiClient.admin.subscriptions.receipts.getUnsent(
          this.query
        );

      return response.data.result;
    },
    async fetchResendList() {
      const response =
        await baanRueJaiClient.admin.subscriptions.receipts.getResend({
          status: "WAIT_FOR_RESEND",
          page: this.query.page,
          page_size: 10,
          seller_trade_party: this.query.filterSellerTradeParty
        });

      return response.data.result;
    },
    handleCurrentChange(page) {
      const route = {
        name: this.$route.name,
        query: {
          ...this.$route.query,
          page,
          isFilteredByPack: this.isFilteredByPack,
          isFilteredByResend: this.isFilteredByResend,
          filterSellerTradeParty: this.query.filterSellerTradeParty
        }
      };

      this.$router.replace(route);
    },
    handleCancelReceipt() {
      this.cancelReceiptDialog.isShow = true;
    },
    handleCloseCancelReceiptDialog() {
      this.cancelReceiptDialog = emptyCancelDialog();
    },
    async handleConfirmCancelReceipt() {
      const {
        documentNumber,
        sellerTradePartyId
      } = this.cancelReceiptDialog;

      if (!documentNumber || !sellerTradePartyId) {
        this.$message.error("กรุณากรอกเลขที่ใบเสร็จและเลือกผู้จัดหาบริการ");

        return;
      }

      this.cancelReceiptDialog.isLoading = true;

      try {
        await baanRueJaiClient.admin.subscriptions.receipts.postCancelReceipt({
          document_number: documentNumber,
          seller_trade_party_id: sellerTradePartyId
        });

        this.$message.success("ยกเลิกใบเสร็จสำเร็จ");

        this.handleCloseCancelReceiptDialog();
        this.setup();
      } catch(error) {
        this.$message.error("ไม่สามารถยกเลิกใบเสร็จได้ กรุณาลองใหม่อีกครั้ง");
      } finally {
        this.cancelReceiptDialog.isLoading = false;
      }
    },
    async handlePackageNotSendEztax() {
      this.query = {
        ...this.$route.query,
        page: this.query.page,
        isFilteredByPack: this.isFilteredByPack
      }
      await this.setupData();
    },
    async handleGetResendReceipt() {
      this.query = {
        ...this.$route.query,
        page: 1,
        isFilteredByResend: this.isFilteredByResend
      };

      this.handleCurrentChange(1);
    },
    handleChangeSellerTradeParty() {
      const route = {
        name: this.$route.name,
        query: {
          ...this.$route.query,
          filterSellerTradeParty: this.query.filterSellerTradeParty
        }
      };

      this.$router.replace(route);
    }
  }
};
</script>

<style lang="scss" scoped>
@import "~@/lib/scss/variables";

.container {
  padding-top: $space;
  padding-bottom: $space;
}

.input {
  &.sellerTradeParty {
    width: 350px
  }
}

.drawer {
  &-title {
    font-size: 20px;
  }

  &-sub-title {
    font-size: 13px;
    color: rgb(133, 131, 131);
  }
}

.receipt-row {
  display: grid;
  grid-gap: 16px;
  grid-template-columns: 100px 220px 330px 200px 90px 1fr;
  align-items: center;
  width: 100%;
  border-bottom: $border;
  padding: 15px 10px;
  font-size: 16px;

  &:hover:not(.header) {
    text-decoration: none;
    background: #efefef;
    color: black;
  }

  &.header {
    padding-bottom: 5px;

    color: #999;
    font-size: 14px;
  }

  > .total,
  > .action {
    text-align: right;
  }

  > .reason {
    padding-left: 18px;
  }
}

.container-receipt {
  padding: 30px;
}
</style>
